// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"848da3e1","453":"2b7a557e","522":"b529948c","858":"d7434b93"}[chunkId] + ".chunk.js";
};